module.exports = __webpack_public_path__ + "img/hipercard.b2232025.svg";